import { CoolLocalStorage } from '@angular-cool/storage';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';
import { ConversationBase } from 'common/store/genesys-cloud/conversations/common/models/conversation-base.model';
import { WorkItemIntegration } from 'common/store/genesys-cloud/work-item-integrations/models/work-item-integrations.model';
import { TranslationLoaderService } from 'shared/services/translation-loader/translation-loader.service';

@Component({
  selector: 'app-genesys-integration-panel',
  templateUrl: './genesys-integration-panel.component.html',
  styleUrls: ['./genesys-integration-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysIntegrationPanelComponent implements OnChanges {
  @Input()
  readonly integration: WorkItemIntegration;
  @Input()
  readonly conversation: ConversationBase;

  integrationUrl = '';
  genesysCloudDomain = '';

  constructor(
    private readonly genesysCloudConfigService: GenesysCloudConfigService,
    private readonly localStorage: CoolLocalStorage,
    private readonly translationLoader: TranslationLoaderService
  ) {}

  ngOnChanges({ integration, conversation }: SimpleChanges): void {
    if (integration || conversation) {
      this.genesysCloudDomain = this.genesysCloudConfigService.determineGenesysCloudDomainFromHostname();
      this.integrationUrl = this.parseIntegrationUrl(this.integration, this.conversation);
    }
  }

  private parseIntegrationUrl(integration: WorkItemIntegration, conversation: ConversationBase): string {
    const locale = this.localStorage.getItem(this.translationLoader.preferredLanguageKey);

    return integration.parseUrl(conversation, this.genesysCloudDomain, locale);
  }
}
